import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Moon, Sun, ChevronDown, Home, Info, Compass } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { AboutSheet } from "@/components/AboutSheet";
import { MicTestButton } from "@/components/MicTest";
import { ScenariovilleSheet } from "@/components/ScenariovilleSheet";
import { FeedbackButton } from "@/components/FeedbackButton";
import { AccountMenu } from "@/components/AccountMenu";

const ThemeToggle = () => {
  const [dark, setDark] = useState(() => localStorage.getItem("theme") === "dark");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);
  return (
    <button
      data-testid="theme-toggle-button"
      onClick={() => setDark((d) => !d)}
      className="btn-ghost h-9 w-9 rounded-full grid place-items-center"
      aria-label="Toggle theme"
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};

const BrandMenu = () => {
  const [about, setAbout] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <button data-testid="header-brand-menu-trigger" className="flex items-center gap-1.5 sm:gap-2.5 outline-none shrink-0">
            <img data-testid="header-logo" src="/logo192.png" alt="RGA Trainer logo" className="h-8 w-8" />
            <span className="font-display font-bold tracking-tight whitespace-nowrap">RGA Trainer</span>
            <span data-testid="beta-badge" className="font-mono text-[10px] font-bold uppercase tracking-widest px-1.5 py-0.5 rounded" style={{ background: "var(--warn)", color: "#fff" }}>Beta</span>
            <ChevronDown size={14} className="hidden sm:block" style={{ color: "var(--ink-3)" }} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-40">
          <DropdownMenuItem data-testid="brand-menu-home" onSelect={() => navigate("/")}><Home size={14} className="mr-2" /> Home</DropdownMenuItem>
          <DropdownMenuItem data-testid="brand-menu-about" onSelect={() => setAbout(true)}><Info size={14} className="mr-2" /> About</DropdownMenuItem>
          <DropdownMenuItem data-testid="brand-menu-guide" onSelect={() => navigate("/guide")}><Compass size={14} className="mr-2" /> Tester guide</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <AboutSheet open={about} onOpenChange={setAbout} />
    </>
  );
};

export const Header = () => (
  <header className="sticky top-0 z-30 border-b" style={{ background: "var(--surface)", borderColor: "var(--line)" }}>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
      <BrandMenu />
      <div className="flex items-center gap-2">
        <FeedbackButton />
        <MicTestButton className="h-9 px-3 hidden sm:flex" label="Mic" testid="header-mic-test-button" />
        <ScenariovilleSheet />
        <ThemeToggle />
        <AccountMenu />
      </div>
    </div>
  </header>
);
